import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>
      ✨ Crafted with creativity by <strong>Jon McIntosh</strong>. This site is for showcase purposes only, featuring logos and images I do not claim ownership of ✨
      </p>
      <p>&copy; {new Date().getFullYear()} Jon McIntosh. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
